import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { viewMaker } from "../../util";
import {
  courseSelectionFormSchema,
  stringLiterals,
  studentProfileFormSchema,
} from "../../data";
import { Button, Tab, Tabs } from "react-bootstrap";

// Show a read-only view of a past application to a student.
function ApplicationView(props) {
  const [key, setKey] = useState("choice-1");
  const studentProfile = props.application;
  const history = useHistory();
  // TODO update this to fetch the application based in its ID and display it.

  return (
    <div className="container text-left">
      <div className="section">
        <div className="text-right">
          <Button
            variant="primary"
            size="sm"
            onClick={() => history.push("/dashboard")}
          >
            Return to dashboard
          </Button>
        </div>
        <h3>{stringLiterals.applicationTitle}</h3>
        {viewMaker(studentProfileFormSchema, studentProfile)}

        <h4>{stringLiterals.courseSelectionTitle}</h4>
        <Tabs id="controlled-tab" activeKey={key} onSelect={(k) => setKey(k)}>
          {["First", "Second", "Third", "Fourth"].map((choice, index) => {
            return (
              <Tab
                key={index}
                eventKey={`choice-${index + 1}`}
                title={<h5>{choice} Choice</h5>}
              >
                {viewMaker(
                  courseSelectionFormSchema(index + 1, []),
                  studentProfile
                )}
              </Tab>
            );
          })}
        </Tabs>
      </div>
    </div>
  );
}

export default ApplicationView;
